import * as React from 'react'
import { Colors } from '../../../constants/colors'
import { BaseIconProps } from '../types'

function SalesforceProfileIcon({ size = 30, color = Colors.N100, title }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 25" fill="none">
      <title>{title}</title>
      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" stroke="#000" />
      <path clipRule="evenodd" d="M3 18h10l1-2s-1.5-3-6-3-6 3-6 3l1 2Z" stroke={color} strokeLinejoin="round" />
      <path
        d="m16.325 6.332.363.508.416-.465c.21-.234.49-.368.79-.368.396 0 .765.236.971.63l.224.428.435-.209c.18-.085.376-.132.583-.132.78 0 1.477.695 1.477 1.635 0 .941-.697 1.637-1.477 1.637a1.35 1.35 0 0 1-.284-.03l-.372-.08-.176.336c-.171.327-.482.525-.818.525a.856.856 0 0 1-.4-.1l-.492-.257-.205.516c-.184.465-.599.761-1.052.761-.472 0-.903-.321-1.074-.819l-.146-.424-.437.1a.921.921 0 0 1-.204.022c-.532 0-1.03-.48-1.03-1.156 0-.447.223-.82.53-1.011l.356-.223-.158-.39a1.512 1.512 0 0 1-.11-.569c0-.808.605-1.405 1.281-1.405.4 0 .768.203 1.009.54Z"
        stroke={color}
      />
    </svg>
  )
}

export default SalesforceProfileIcon
